const CopyToClipboard = (props) => {
    return (
        <svg {...props} width="23" height="28" viewBox="0 0 23 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 21.9083C7.26667 21.9083 6.63889 21.6472 6.11667 21.125C5.59444 20.6027 5.33333 19.975 5.33333 19.2416V3.24162C5.33333 2.50828 5.59444 1.88051 6.11667 1.35828C6.63889 0.836062 7.26667 0.574951 8 0.574951H20C20.7333 0.574951 21.3611 0.836062 21.8833 1.35828C22.4056 1.88051 22.6667 2.50828 22.6667 3.24162V19.2416C22.6667 19.975 22.4056 20.6027 21.8833 21.125C21.3611 21.6472 20.7333 21.9083 20 21.9083H8ZM8 19.2416H20V3.24162H8V19.2416ZM2.66667 27.2416C1.93333 27.2416 1.30556 26.9805 0.783333 26.4583C0.261111 25.9361 0 25.3083 0 24.5749V5.90828H2.66667V24.5749H17.3333V27.2416H2.66667Z" fill="currentColor" />
        </svg>
    )
}

export default CopyToClipboard;


